if (window.location.hash) {
    setTimeout(function () {
        window.scrollTo(0, 0);
    }, 1);
}